import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <p className="text-xs font-medium tracking-widest text-primary-600 uppercase mb-2">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-semibold text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>
        )}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap font-medium shrink-0"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}